module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAARpJREFUSA1j/N+gzcZw42cTAzNzMsOf3yIMtAQsrG8Y/v6dy6DBXscCtpSbt4AhtpqdQVSGltYyMLx+IsKwuLWQ4cZnBob/0eqv/x9Y859uAGQX0E4mcPDS2qfI4QiyCxilTMhi9GSPWkx8aG+ezcAAwmQC8oP62GYGhqNATCYg32IyLYRpG7UYFhI0pwcsqFnweg2UXXCl3Gf3IFor/LAbYe3LwOCbil0OKIrfYpA2Rpx6IRKE5HFox28xyMW4XF0J9Ol/oKntm3AYjV94wOJ41GL8EUNF2QELavypGp8PrYD5lAJAvsW4shmRjhmwoB6JFoO6Fa+fEBkzVFAGsgtoJwu4L7O4tQBoJD26MAzALswvkJ2MA9VpAwBK1rjBvVrFzAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unselected.png
// module id = 1399
// module chunks = 32